"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRADE_IN_TITLES = void 0;
var interfaces_1 = require("./components/TradeIn/interfaces");
exports.TRADE_IN_TITLES = (_a = {},
    _a[interfaces_1.VehicleBrands.suzuki] = 'Сдаю в трейд-ин автомобиль Suzuki',
    _a[interfaces_1.VehicleBrands.other] = 'Сдаю в трейд-ин автомобиль другого бренда',
    _a);
